
























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { DataCenters } from '@/modules/shared/shared/domain/constants/constants';
import * as rules from '@/modules/shared/shared/domain/rules';
import moment from 'moment';
import { Watch } from 'vue-property-decorator';
import { reportsManagement } from '@/modules/shared/shared/store/namespaces';
import { ReportsManagementActions } from '@/modules/reports/management/store/reports-management.actions';

@Component({
    name: 'download-incident',
})
export default class DownloadIncidentReportModal extends Vue {
    dialog: boolean = false;
    locations = [DataCenters.DATA_CENTER_CARACAS, DataCenters.DATA_CENTER_VALENCIA];
    isLoading: boolean = false;
    dateMenu: boolean = false;
    date: string | null = null;
    dateSelected: string | null = null;
    datacenterSelected: number | null = null;

    selectTypeInterruption: number | null = null;
    typeInterruption: { id: number; name: string }[] = [
        {
            id: 0,
            name: 'Detalle de interrupciones',
        },
        {
            id: 1,
            name: 'Resumen de interrupciones',
        },
    ];

    maxDate = moment().format('yyyy-MM-DD');
    rules: any = rules;

    $refs!: {
        form: any;
        picker: any;
    };

    close() {
        this.$refs.form.reset();
        this.dialog = false;
    }

    open() {
        this.dialog = true;
    }

    public setDate(date: string) {
        this.date = date ? date.substring(0, 4) : date;
    }

    async download() {
        this.isLoading = true;
        if (this.$refs.form.validate()) {
            const failed = await this.downloadReport({
                dataCenter: this.datacenterSelected!,
                summary: this.selectTypeInterruption!,
                year: this.date!,
            });
            if (!failed) {
                this.close();
            } else {
                failed.showError();
            }
        }
        this.isLoading = false;
    }

    @Watch('dateMenu')
    watchMenu(val) {
        val &&
            this.$nextTick(
                () => ((this.$refs.picker as { activePicker: string }).activePicker = 'YEAR'),
            );
    }

    @reportsManagement.Action(ReportsManagementActions.DOWNLOAD_INCIDENTS)
    downloadReport!: (data: {
        dataCenter: number;
        year: string;
        summary: number;
    }) => Promise<RequestResponse>;
}
